<template>
  <div class="slider">
    <label><slot></slot></label>
    <input type="range" :min="min" :max="max" :step="step" v-model="model"/>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineModel } from 'vue'
defineProps({
  min: Number,
  max: Number,
  step: Number
})

const model = defineModel<number>({
  set (value) {
    if (typeof value === 'string') value = parseInt(value)
    return value
  }
})
</script>

<style lang="scss">
  .slider {
    label {
      display: block;
    }
    input {
      width: 80vw;
      height: 50px
    }
  }
</style>
